import React, { useState, useMemo } from 'react';

import { createNewProfile } from '../../api/profile';
import { useAuth } from '../../contexts/AuthContext';
import { ICreateProfilePayload } from '../../types/Profile';
import CreateProfileForm from '../CreateProfileForm';
import AuthSection from '../AuthSection';

import styles from './Onboarding.module.scss';

const WELCOME_TITLE = 'Добро пожаловать в NUMIQUE!';
const WELCOME_SUBTITLE = 'Рады вас видеть с нами! Давайте создадим ваш профиль!';
const ERROR_MESSAGE = 'Ошибка при создании профиля. Пожалуйста, попробуйте позже.';

const FormHeader = () => (
  <div className={styles.formHeader_title}>
    <h1>{WELCOME_TITLE}</h1>
    <p>{WELCOME_SUBTITLE}</p>
  </div>
);

export function Onboarding(): React.JSX.Element {
  const [, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { setProfile } = useAuth();

  const handleSubmit = async (payload: ICreateProfilePayload) => {
    setLoading(true);
    setError(null);

    try {
      const profile = await createNewProfile(payload);
      await setProfile(profile);
    } catch {
      setError(ERROR_MESSAGE);
    } finally {
      setLoading(false);
    }
  };

  const formHeader = useMemo(() => <FormHeader />, []);

  return (
    <AuthSection className={styles.onboarding}>
      <CreateProfileForm styles={styles} onSubmit={handleSubmit} header={formHeader} />
      {error && <div className={styles.error}>{error}</div>}
    </AuthSection>
  );
}
